import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Observable } from 'rxjs';

import { AddExistingCoacheeEvents } from 'presentation/app-sidebar/sidebar-add-existing-coachee/events/add-existing-coachee.events';
import { SidebarAddExistingCoacheeController } from 'presentation/app-sidebar/sidebar-add-existing-coachee/sidebar-add-existing-coachee.controller';

@Component({
	selector: 'spr-sidebar-add-existing-coachee',
	templateUrl: './sidebar-add-existing-coachee.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [SidebarAddExistingCoacheeController],
})
export class SidebarAddExistingCoacheeComponent {
	public form: FormGroup;
	public formValid$: Observable<boolean>;
	public coacheesWithoutCoach$: Observable<SelectItem[]>;
	@Output() public addClick = new EventEmitter<AddExistingCoacheeEvents>();

	constructor(private _controller: SidebarAddExistingCoacheeController) {
		this.coacheesWithoutCoach$ = _controller.coacheesWithoutCoach$;
		this.formValid$ = _controller.selectValid();
		this.form = _controller.form;
	}

	public onAddClick() {
		this.addClick.emit(this._controller.form.value);
	}
}
